<template>
  <header id="header">
    <div class="inner-header clearfix">
      <el-row>
        <el-col :xs="24" :sm="3" :md="3" :lg="3">
          <h1 class="logo">
            <!-- <a :href="this.$API.ROOT_URL"> -->
            <a href="javascript:;" @click="toWelcomePage">
              <img src="../assets/logo.png" alt="" />
            </a>
          </h1>
        </el-col>
        <el-col :xs="24" :sm="21" :md="21" :lg="21">
          <div class="user-box">
            <a style="margin-right:20px" href="https://docs.qq.com/doc/DVUx3YW5GZWxsdWVx">帮助中心</a>
            <a @click="showUserInfo">{{ userName }}</a>
            <span>|</span>
            <a class="linka" @click="userLogout">退出</a>
          </div>
          <!--
                <nav class='nav'>
                    <ul>
                       <template v-for="(menu, index) in roleMenu">
                          <li>
                              <a :href='menu.url'>{{menu.title}}</a>
                          </li>
                       </template>
                    </ul>
                </nav>
                -->
        </el-col>
      </el-row>
    </div>
  </header>
</template>

<script>
import Dictionary from "@/config/dictionary";
import Commons from "@/config/commons";
import VueCookie from "vue-cookie";

export default {
  name: "header-bar",
  data() {
    return {
      userName: "",
      platformList: [],
      roleMenu: [],
    };
  },
  computed: {
    apps: function () {
      const apps = Dictionary.getPlatformAppList();
      this.platformList = apps;
      return apps;
    },
    appUrl: function () {
      return this.$API.LOGIN_URL;
    },
  },
  mounted() {
    this.loadCurrentUser();
    this.updateMenu();
  },
  methods: {
    handleCommand(cmd) {
      let url = "";
      for (let i in this.platformList) {
        if (cmd == this.platformList[i].code) {
          url = this.platformList[i].url;
          break;
        }
      }
      if (cmd == "DeviceService") {
        this.$router.push({ name: "welcome" });
      } else {
        if (url != "") {
          window.open(url);
        } else {
          this.$message({
            message: "尚未开通,尽情期待!",
            type: "warning",
          });
        }
      }
      console.log(url);
    },
    loadCurrentUser() {
      const userName = sessionStorage.getItem("userName");
      console.log("name=" + userName);
      if (userName) {
        this.userName = userName;
      }
    },
    showUserInfo() {
      this.$router.push({
        name: "userinfo",
      });
    },
    toBorrow(){
       this.$router.push({
        //  name:'borrow'
       })
    },
    handleCommandMenu(cmd) {
      console.log(cmd);
      if (cmd.url !== "empty") {
        if (cmd.type !== "bot") {
          window.location.href = cmd.url;
        } else {
          window.open(cmd.url);
        }
      }
    },
    userLogout() {
      this.$http
        .post(this.$API.USER_LOGOUT, {})
        .then((resp) => {
          let res = resp.data;
          console.log(res);
          this.toLogin();
          if (true || res.error == "success" || res.rc == 0) {
          }
        })
        .catch((error) => {
          Commons.handleApiError(this, error);
          this.toLogin();
        });
    },
    toLogin() {
      const domain = {
        domain: Commons.getDomain(),
      };

      sessionStorage.removeItem("localMenu");
      sessionStorage.removeItem("userName");
      sessionStorage.removeItem("userAccount");
      VueCookie.delete("USER_NAME", domain);
      this.$cookie.delete("WEBUI_SESSION_ID", domain);
      this.$cookie.delete("WEBUI_WEBAPI_TOKEN", domain);
      VueCookie.delete("WEBUI_SESSION_ID");
      VueCookie.delete("WEBUI_WEBAPI_TOKEN"); 
      this.$router.push({path:"/login"})

      // let _loginUrl = this.$API.LOGIN_URL;
      // window.location.href = _loginUrl;
    },
    toWelcomePage() {
      this.$router.push({path:"/"})
    },
    updateMenu() {
      var localMenu = sessionStorage.getItem("localMenu");
      if (localMenu && typeof localMenu == "string") {
        console.log("load menu from sessionStorage");
        this.roleMenu = JSON.parse(localMenu);
        return;
      }
      this.$http
        .post(this.$API.ROLE_MEUN, {
          mainMenuId: "root",
          system: "erf",
        })
        .then((resp) => {
          let m = resp.data;
          if (m.rc == 0) {
            this.roleMenu = m.menus;
            console.log("fdafda");
            sessionStorage.setItem("localMenu", JSON.stringify(m.menus));
          }
        })
        .catch((error) => {
          Commons.handleApiError(this, error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.p {
  background: #009e7d;
}
#header {
  min-height: 60px;
  //border-bottom: 1px solid #e6e6e6;
}

.logo {
  background-color: #009e7d;
  font-weight: normal;
  font-size: 16px;
  // width: 256px;
  a {
    display: block;
    // text-align: center;
    height: 90px;
    line-height: 80px;
    overflow: hidden;
    color: #fff;
    padding-left: 30px;

    img {
      width: 108px;
      height: 58px;
      margin-top: 20px;
    }
  }
}

.nav {
  float: left;
  line-height: 60px;
  height: 100%;
  font-size: 14px;
  ul {
    width: 100%;
    li {
      float: left;
      padding: 0 30px;
      font-size: 14px;
      a {
        display: block;
        &.router-link-active {
          color: #00a3ff;
        }
      }
      &.item-dropdown {
        line-height: 40px;
        padding: 10px 30px;
        .el-dropdown-link {
          cursor: pointer;
        }
      }
    }
  }
}

.user-box {
  padding: 0 3%;
  font-size: 14px;
  float: right;
  line-height: 60px;
  height: 100%;
  span {
    margin: 0px 5px;
  }
}

.linka {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Header.vue?ccdc7bde